<div class="container-fluid">
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-primary upp-header row"
    (window:resize)="updateMenuTitleVisibility()"
    id="header"
  >
    <div class="d-flex w-100 h-100 align-items-center">
      <button class="navbar-toggler" type="button" (click)="toggleSideNav()" id="toggleButton">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="appTitle">
        <a id="appNameLink" class="navbar-brand" href="#">{{ applicationName }}</a>
      </div>
      <div id="menuTitle" class="flex-grow-1" [ngbCollapse]="isTitleHidden()"><strong>-</strong> {{ menuTitle }}</div>
      @if (user?.partitions) {
      <div ngbDropdown class="d-inline-block ms-auto">
        <button class="btn btn-primary justify-content-center" id="userPartitions" ngbDropdownToggle>
          {{ user?.selectedPartition }}&nbsp;
        </button>
        <div ngbDropdownMenu>
          @for (partition of user?.partitions; track partition) {
          <div>
            @if (partition !== user?.selectedPartition) {
            <div>
              <button class="dropdown-item" (click)="onSelectPartition(partition)" [disabled]="lookup">
                {{ partition }}
              </button>
            </div>
            }
          </div>
          }
        </div>
      </div>
      }
      <div ngbDropdown class="d-inline-block" [ngClass]="user?.partitions ? '' : 'ms-auto'" placement="bottom-end">
        <button class="btn btn-primary justify-content-center" id="userAlias" ngbDropdownToggle>
          <span class="fa-user-circle me-2"></span>{{ user?.userAlias }}&nbsp;
        </button>
        <div ngbDropdownMenu class="dropdown-menu-end">
          @if (!user?.selectedPartition) {
          <div class="dropdown-item"> <span class="fa-users me-2"></span> {{ user?.organization }}</div>
          }
          <button class="dropdown-item" (click)="onSignOffClicked()">
            <span class="fa-sign-out me-2"></span
            ><ng-container i18n="@@upp.global.header.signoff">Sign Off</ng-container>
          </button>
          @if (troubleshootingPanelActivate) {
          <hr class="dropdown-divider" />
          <div class="d-flex flex-column px-3 py-3 request-info-container">
            <div class="d-flex align-items-center justify-content-start">
              <small class="text-muted" i18n="@@upp.global.header.amarequest">
                Ama request ID: {{ amaRequestData?.requestId }}
              </small>
              <app-copy-to-clipboard-button
                [value]="amaRequestData?.requestId || ''"
                ariaLabel="Copy request ID to clipboard"
                i18n-ariaLabel="@@upp.global.button.copyRequestId"
              ></app-copy-to-clipboard-button>
            </div>
            <small class="text-muted mt-1" i18n="@@upp.global.header.datetime">
              Date and time: {{ amaRequestData?.timestamp }}
            </small>
          </div>
          }
        </div>
      </div>
    </div>
  </nav>
  @if (displayAlertPartitionChange) {
  <div>
    <ngb-alert
      dfInsertAlertIcon
      (closed)="displayAlertPartitionChange = false"
      type="info"
      class="m-0"
      i18n="@@upp.global.text.partitionSwitchSuccessful"
    >
      You have successfully switched to {{ user?.selectedPartition }}
    </ngb-alert>
  </div>
  }
</div>
